import { render, staticRenderFns } from "./LanguageMenu.vue?vue&type=template&id=324fec8f&scoped=true"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"
import style0 from "./LanguageMenu.vue?vue&type=style&index=0&id=324fec8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fec8f",
  null
  
)

export default component.exports